// import React, { useContext, useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import Navbar from "../components/Navbar";
// import BottomNavigation from "../components/BottomNavigation";
// // import SportCategory from "../components/SportCategory";
// import { MatchContext } from "../context/MatchContext";
// import { API_URL } from "../config";
// import Carousel from 'react-bootstrap/Carousel';

// const parseMatchTime = (value) => {
//   if (!value) return null;

//   if (value instanceof Date) {
//     return Number.isNaN(value.getTime()) ? null : value;
//   }

//   if (typeof value === "number") {
//     const normalizedValue = value < 10000000000 ? value * 1000 : value;
//     const parsed = new Date(normalizedValue);
//     return Number.isNaN(parsed.getTime()) ? null : parsed;
//   }

//   if (typeof value === "string") {
//     const parsed = new Date(value);
//     if (!Number.isNaN(parsed.getTime())) return parsed;

//     const fallback = new Date(value.replace(" ", "T"));
//     return Number.isNaN(fallback.getTime()) ? null : fallback;
//   }

//   return null;
// };

// /* =========================================
//    ✅ HELPER: Format Styles
// ========================================= */
// const getFormatStyle = (format) => {
//   const f = format?.toUpperCase() || "";

//   if (f.includes("T20") || f.includes("IPL") || f.includes("BBL")) {
//     return {
//       background: "linear-gradient(135deg, #FF3CAC 0%, #784BA0 100%)",
//       color: "#fff",
//       label: "T20"
//     };
//   }
//   if (f.includes("ODI")) {
//     return {
//       background: "linear-gradient(135deg, #00C6FF 0%, #0072FF 100%)",
//       color: "#fff",
//       label: "ODI"
//     };
//   }
//   if (f.includes("TEST")) {
//     return {
//       background: "linear-gradient(135deg, #EB3349 0%, #F45C43 100%)",
//       color: "#fff",
//       label: "TEST"
//     };
//   }
//   if (f.includes("T10")) {
//     return {
//       background: "linear-gradient(135deg, #F7971E 0%, #FFD200 100%)",
//       color: "#000",
//       label: "T10 LEAGUE"
//     };
//   }
//   // Default
//   return {
//     background: "linear-gradient(135deg, #302b63 0%, #24243e 100%)",
//     color: "#fff",
//     label: "MATCH"
//   };
// };

// /* =========================================
//    ✅ FIXED COMPONENT: Running Timer (Home.jsx)
// ========================================= */
// const CountdownTimer = ({ matchStartTime }) => {
//   const [timeLeft, setTimeLeft] = useState("");

//   useEffect(() => {
//     const calculateTimeLeft = () => {
//       if (!matchStartTime) return "TBD";

//       try {
//         const parsedMatchTime = parseMatchTime(matchStartTime);
//         const start = parsedMatchTime?.getTime();
//         const now = new Date().getTime();

//         if (!start || Number.isNaN(start)) return "TBD";

//         const diff = start - now;
//         if (diff <= 0) return "Live";

//         // Sirf Total Hours, Minutes, aur Seconds nikalenge (Days hata diya)
//         const totalHours = Math.floor(diff / (1000 * 60 * 60));
//         const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//         const seconds = Math.floor((diff % (1000 * 60)) / 1000);

//         return `${totalHours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;
//       } catch (err) {
//         return "TBD";
//       }
//     };

//     setTimeLeft(calculateTimeLeft());
//     const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
//     return () => clearInterval(timer);
//   }, [matchStartTime]);

//   return (
//     <span style={{ fontVariantNumeric: 'tabular-nums', color: timeLeft === "Live" ? "red" : "inherit" }}>
//       {timeLeft}
//     </span>
//   );
// };

// function Home() {
//   const navigate = useNavigate();
//   const { upcomingMatches, loading } = useContext(MatchContext);

//   const [banners, setBanners] = useState([]);
//   const [loadingBanners, setLoadingBanners] = useState(true);

//   useEffect(() => {
//     const fetchBanners = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/api/banners`);
//         if (res.data.success) {
//           setBanners(res.data.banners);
//         }
//       } catch (error) {
//         console.error("Banner fetch error", error);
//       } finally {
//         setLoadingBanners(false);
//       }
//     };
//     fetchBanners();
//   }, []);

//   // ✅ SHIMMER LOADER
//   if (loading) return (
//     <>
//       <Navbar />
//       <div style={{ paddingBottom: "90px", background: "#f0f2f5", minHeight: "100vh" }} className="mt-5 pt-3">
//         {/* <SportCategory /> */}
//         <div className="container-fluid px-3 px-md-4 py-4">

//           {/* 🔥 FIX: Responsive Shimmer for Banner */}
//           <div className="placeholder-glow mb-4">
//             <div className="placeholder w-100 rounded-4 shadow-sm responsive-banner" style={{ backgroundColor: "#800000", opacity: 0.15 }}></div>
//           </div>

//           <div className="mb-3"><span className="placeholder col-4 bg-secondary opacity-25 rounded"></span></div>
//           <div className="row g-3 placeholder-glow">
//             {[1, 2, 3].map((i) => (
//               <div key={i} className="col-12 col-md-6">
//                 <div className="card border-0 p-3" style={{ borderRadius: "20px", height: "180px", background: "#fff" }}>
//                   <div className="d-flex justify-content-between mb-4">
//                     <span className="placeholder col-3 bg-secondary opacity-10 rounded"></span>
//                     <span className="placeholder col-2 bg-secondary opacity-10 rounded-pill"></span>
//                   </div>
//                   <div className="d-flex justify-content-between align-items-center px-3">
//                     <span className="placeholder rounded-circle bg-secondary opacity-10" style={{ width: '50px', height: '50px' }}></span>
//                     <span className="placeholder col-2 bg-secondary opacity-10 rounded"></span>
//                     <span className="placeholder rounded-circle bg-secondary opacity-10" style={{ width: '50px', height: '50px' }}></span>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//       <BottomNavigation />
//     </>
//   );

//   return (
//     <>
//       <Navbar />
//       <div style={{ paddingBottom: "90px", background: "#f0f2f5", minHeight: "100vh" }} className="mt-5 pt-3">
//         {/* <SportCategory /> */}

//         <div className="container-fluid px-3 px-md-4 py-4">

//           {/* 🔥 DYNAMIC BANNER SLIDER (React-Bootstrap) 🔥 */}
//           {loadingBanners ? (
//             // 💀 SHIMMER LOADER FOR BANNER
//             <div className="placeholder-glow mb-4">
//               <div className="placeholder w-100 rounded-4 shadow-sm responsive-banner" style={{ backgroundColor: "#800000", opacity: 0.15 }}></div>
//             </div>
//           ) : (
//             // 🌟 ACTUAL SLIDER
//             banners.length > 0 && (
//               <Carousel
//                 className="mb-4 shadow-sm animate-fade-in custom-carousel"
//                 style={{ borderRadius: "20px", overflow: "hidden" }}
//                 interval={3000}       // Auto-slide every 3 seconds
//                 controls={false}      // Hides Left/Right Arrows (Phone me ajeeb lagte hain)
//                 indicators={true}     // Shows the bottom dots
//                 pause="hover"         // Touch/Hover karne par ruk jayega
//               >
//                 {banners.map((banner, index) => (
//                   <Carousel.Item key={banner._id || index}>
//                     {/* 🔥 FIX: Responsive Image Class Maintained */}
//                     <img
//                       src={banner.imageUrl}
//                       className="d-block w-100 object-fit-cover responsive-banner"
//                       alt={`Promo Banner ${index + 1}`}
//                     />
//                   </Carousel.Item>
//                 ))}
//               </Carousel>
//             )
//           )}

//           {/* Upcoming Matches Heading */}
//           <div className="mb-3 d-flex align-items-center gap-2">
//             <i className="bi bi-fire text-danger fs-5"></i>
//             <h5 className="fw-bold mb-0 text-dark" style={{ letterSpacing: '-0.5px' }}>Upcoming Matches</h5>
//           </div>

//           {!loading && upcomingMatches.length === 0 && (
//             <div className="text-center py-5 text-muted animate-fade-in">
//               <div className="mb-3 bg-white rounded-circle d-inline-flex p-4 shadow-sm">
//                 <i className="bi bi-calendar-x fs-1 opacity-25"></i>
//               </div>
//               <p className="fw-medium">No upcoming matches found.</p>
//             </div>
//           )}

//           <div className="row g-3">
//             {upcomingMatches.filter(match => {
//               const matchStatus = (match.status || "").toLowerCase();
//               return matchStatus === "upcoming" || matchStatus === "lineup_out";
//             }).map((match, index) => {

//               // Colors & Formats
//               const normalizedStatus = (match.status || "").toLowerCase();
//               const formatInfo = getFormatStyle(match.matchType || "MATCH");
//               const team1Color = match.team1?.color || "#333";
//               const team2Color = match.team2?.color || "#333";
//               const isLineupsOut = normalizedStatus === "lineup_out";
//               const showLineupIndicator = normalizedStatus === "lineup_out";

//               return (
//                 <div key={index} className="col-12 col-md-6 col-lg-4">
//                   <div
//                     className="card border-0 position-relative animate-fade-in card-hover overflow-hidden"
//                     onClick={() => navigate(`/contests/${match.matchId}`, { state: { matchData: match } })}
//                     style={{
//                       borderRadius: "24px",
//                       background: "#ffffff",
//                       boxShadow: "0 10px 30px -10px rgba(0,0,0,0.08)",
//                       cursor: "pointer",
//                       border: isLineupsOut ? "1.5px solid #198754" : "1.5px solid transparent"
//                     }}
//                   >
//                     {/* === CARD HEADER (Series Name & Format) === */}
//                     <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom border-light bg-light bg-opacity-25">
//                       <small className="text-muted text-uppercase fw-bold text-truncate" style={{ fontSize: '10px', maxWidth: '70%' }}>
//                         {match.seriesName || match.matchType}
//                       </small>
//                       <span className="badge border-0 shadow-sm"
//                         style={{ background: formatInfo.background, color: formatInfo.color, fontSize: '9px', letterSpacing: '0.5px' }}
//                       >
//                         {formatInfo.label}
//                       </span>
//                     </div>

//                     {/* === TEAMS SECTION === */}
//                     <div className="card-body py-3 px-2">
//                       <div className="d-flex justify-content-between align-items-center px-2">

//                         {/* Team 1 */}
//                         <div className="d-flex flex-column align-items-center" style={{ width: '35%' }}>
//                           <div className="position-relative">
//                             <div className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
//                               style={{
//                                 width: "56px", height: "56px",
//                                 background: `linear-gradient(135deg, ${team1Color} 0%, #000 100%)`,
//                                 border: "3px solid #fff", color: "#fff", fontWeight: "800", fontSize: "14px"
//                               }}
//                             >
//                               {match.team1?.image ? (
//                                 <img src={match.team1.image} alt="" className="w-100 h-100 rounded-circle object-fit-cover" />
//                               ) : (
//                                 match.team1?.code?.[0] || "T1"
//                               )}
//                             </div>
//                             <div className="position-absolute bottom-0 start-50 translate-middle-x bg-white px-2 rounded-pill border shadow-sm" style={{ fontSize: '9px', whiteSpace: 'nowrap', marginTop: '-10px' }}>
//                               {match.team1?.code}
//                             </div>
//                           </div>
//                           <div className="fw-bold text-dark text-truncate w-100 text-center mt-2" style={{ fontSize: "13px" }}>
//                             {match.team1?.name}
//                           </div>
//                         </div>

//                         {/* VS / Timer Center */}
//                         <div className="text-center d-flex flex-column align-items-center" style={{ width: '30%' }}>
//                           <span className="text-secondary opacity-25 fw-black" style={{ fontSize: "28px", fontFamily: 'sans-serif' }}>VS</span>
//                           <div className="mt-1 d-flex align-items-center gap-1 text-danger bg-danger-subtle px-2 py-1 rounded-pill" style={{ fontSize: '10px', fontWeight: '600' }}>
//                             <i className="bi bi-stopwatch"></i>
//                             <CountdownTimer matchStartTime={match.matchStartTime || match.startTime} />
//                           </div>
//                         </div>

//                         {/* Team 2 */}
//                         <div className="d-flex flex-column align-items-center" style={{ width: '35%' }}>
//                           <div className="position-relative">
//                             <div className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
//                               style={{
//                                 width: "56px", height: "56px",
//                                 background: `linear-gradient(135deg, ${team2Color} 0%, #000 100%)`,
//                                 border: "3px solid #fff", color: "#fff", fontWeight: "800", fontSize: "14px"
//                               }}
//                             >
//                               {match.team2?.image ? (
//                                 <img src={match.team2.image} alt="" className="w-100 h-100 rounded-circle object-fit-cover" />
//                               ) : (
//                                 match.team2?.code?.[0] || "T2"
//                               )}
//                             </div>
//                             <div className="position-absolute bottom-0 start-50 translate-middle-x bg-white px-2 rounded-pill border shadow-sm" style={{ fontSize: '9px', whiteSpace: 'nowrap' }}>
//                               {match.team2?.code}
//                             </div>
//                           </div>
//                           <div className="fw-bold text-dark text-truncate w-100 text-center mt-2" style={{ fontSize: "13px" }}>
//                             {match.team2?.name}
//                           </div>
//                         </div>

//                       </div>
//                     </div>

//                     {/* === BOTTOM STRIP === */}
//                     <div className={`px-3 py-2 border-top d-flex justify-content-between align-items-center ${isLineupsOut ? "bg-success-subtle border-success-subtle" : "bg-light bg-opacity-50 border-light"}`}>
//                       <div className="d-flex align-items-center gap-1">
//                         <span className={`badge ${isLineupsOut ? "bg-success" : "bg-success-subtle text-success border border-success-subtle"} rounded-1`} style={{ fontSize: '9px' }}>MEGA</span>
//                         <span className="fw-bold text-dark" style={{ fontSize: '11px' }}>₹50 Crores</span>
//                       </div>
//                       {showLineupIndicator ? (
//                         <div className="d-flex align-items-center gap-1 text-success fw-bold" style={{ fontSize: '10px' }}>
//                           <span className="opacity-blink" style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: '#198754', display: 'inline-block' }}></span>
//                           <span>LINEUP OUT</span>
//                         </div>
//                       ) : isLineupsOut ? (
//                         <div className="d-flex align-items-center gap-1 text-success fw-bold" style={{ fontSize: '10px' }}>
//                           <i className="bi bi-check-circle-fill"></i>
//                           <span>Team Available</span>
//                         </div>
//                       ) : (
//                         <div className="d-flex align-items-center gap-1 text-muted" style={{ fontSize: '10px' }}>
//                           <i className="bi bi-shield-check text-success"></i>
//                           <span>Guaranteed</span>
//                         </div>
//                       )}
//                     </div>

//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>

//         <style>{`
//             .animate-fade-in { animation: fadeIn 0.5s ease-out; }
//             .card-hover { transition: transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94); }
//             .card-hover:active { transform: scale(0.98); }
//             .blink-effect { animation: blink 1.5s infinite; }
//             .opacity-blink { animation: opacityBlink 1.2s infinite; }
//             .fw-black { font-weight: 900; }
//             @keyframes fadeIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
//             @keyframes blink { 50% { opacity: 0.5; } }
//             @keyframes opacityBlink { 0%, 100% { opacity: 1; } 50% { opacity: 0.25; } }

//             /* 🔥 FIX: RESPONSIVE BANNER HEIGHT */
//             .responsive-banner {
//                 height: 100px; /* Mobile par patli strip */
//                 background-color: #800000;
//             }
            
//             @media (min-width: 768px) {
//                 .responsive-banner {
//                     height: 160px; /* Laptop/Tablet par regular size */
//                 }
//             }
//         `}</style>
//       </div>

//       <BottomNavigation />
//     </>
//   );
// }

// export default Home;



import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import BottomNavigation from "../components/BottomNavigation";
// import SportCategory from "../components/SportCategory";
import { MatchContext } from "../context/MatchContext";
import { API_URL } from "../config";
import Carousel from 'react-bootstrap/Carousel';

const parseMatchTime = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "number") {
    const normalizedValue = value < 10000000000 ? value * 1000 : value;
    const parsed = new Date(normalizedValue);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  if (typeof value === "string") {
    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) return parsed;

    const fallback = new Date(value.replace(" ", "T"));
    return Number.isNaN(fallback.getTime()) ? null : fallback;
  }

  return null;
};

/* =========================================
   ✅ HELPER: Format Styles
========================================= */
const getFormatStyle = (format) => {
  const f = format?.toUpperCase() || "";

  if (f.includes("T20") || f.includes("IPL") || f.includes("BBL")) {
    return {
      background: "linear-gradient(135deg, #FF3CAC 0%, #784BA0 100%)",
      color: "#fff",
      label: "T20"
    };
  }
  if (f.includes("ODI")) {
    return {
      background: "linear-gradient(135deg, #00C6FF 0%, #0072FF 100%)",
      color: "#fff",
      label: "ODI"
    };
  }
  if (f.includes("TEST")) {
    return {
      background: "linear-gradient(135deg, #EB3349 0%, #F45C43 100%)",
      color: "#fff",
      label: "TEST"
    };
  }
  if (f.includes("T10")) {
    return {
      background: "linear-gradient(135deg, #F7971E 0%, #FFD200 100%)",
      color: "#000",
      label: "T10 LEAGUE"
    };
  }
  // Default
  return {
    background: "linear-gradient(135deg, #302b63 0%, #24243e 100%)",
    color: "#fff",
    label: "MATCH"
  };
};

/* =========================================
   ✅ FIXED COMPONENT: Running Timer (Home.jsx)
========================================= */
const CountdownTimer = ({ matchStartTime }) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const calculateTimeLeft = () => {
      if (!matchStartTime) return "TBD";

      try {
        const parsedMatchTime = parseMatchTime(matchStartTime);
        const start = parsedMatchTime?.getTime();
        const now = new Date().getTime();

        if (!start || Number.isNaN(start)) return "TBD";

        const diff = start - now;
        if (diff <= 0) return "Live";

        // Sirf Total Hours, Minutes, aur Seconds nikalenge (Days hata diya)
        const totalHours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        return `${totalHours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;
      } catch (err) {
        return "TBD";
      }
    };

    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, [matchStartTime]);

  return (
    <span style={{ fontVariantNumeric: 'tabular-nums', color: timeLeft === "Live" ? "red" : "inherit" }}>
      {timeLeft}
    </span>
  );
};

function Home() {
  const navigate = useNavigate();
  const { upcomingMatches, loading } = useContext(MatchContext);

  const [banners, setBanners] = useState([]);
  const [loadingBanners, setLoadingBanners] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/banners`);
        if (res.data.success) {
          setBanners(res.data.banners);
        }
      } catch (error) {
        console.error("Banner fetch error", error);
      } finally {
        setLoadingBanners(false);
      }
    };
    fetchBanners();
  }, []);

  // 🚧 WORK IN PROGRESS MODAL - REMOVE THIS BLOCK WHEN WEBSITE IS READY
  // Modal intentionally has no close icon and cannot be dismissed by clicking outside.
  const workInProgressModal = (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="win11-work-in-progress-title"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        background: "rgba(0, 0, 0, 0.65)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "440px",
          background: "#ffffff",
          borderRadius: "20px",
          padding: "28px 24px 24px",
          textAlign: "center",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
        }}
      >
        <div style={{ fontSize: "44px", marginBottom: "12px" }} aria-hidden="true">
          🚧
        </div>
        <h2
          id="win11-work-in-progress-title"
          style={{ color: "#800000", fontWeight: 800, fontSize: "24px", marginBottom: "12px" }}
        >
          Website Under Development!
        </h2>
        <p style={{ color: "#444444", fontSize: "15px", lineHeight: 1.6, marginBottom: "18px" }}>
          WIN11 is currently under development. Some features may not work properly.
          Please visit again later.
        </p>
        <div
          style={{
            background: "#fff3cd",
            color: "#664d03",
            borderRadius: "10px",
            padding: "10px 12px",
            fontSize: "13px",
            marginBottom: "20px",
          }}
        >
          Work in progress — thank you for your patience.
        </div>
        <button
          type="button"
          onClick={() => navigate("/login", { replace: true })}
          style={{
            width: "100%",
            border: "none",
            borderRadius: "10px",
            padding: "13px 16px",
            background: "#800000",
            color: "#ffffff",
            fontSize: "15px",
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          OK, LOG OUT
        </button>
      </div>
    </div>
  );
  // 🚧 END WORK IN PROGRESS MODAL

  // ✅ SHIMMER LOADER
  if (loading) return (
    <>
      <Navbar />
      {/* 🚧 WORK IN PROGRESS MODAL RENDER - REMOVE THIS LINE WHEN WEBSITE IS READY */}
      {workInProgressModal}
      <div style={{ paddingBottom: "90px", background: "#f0f2f5", minHeight: "100vh" }} className="mt-5 pt-3">
        {/* <SportCategory /> */}
        <div className="container-fluid px-3 px-md-4 py-4">

          {/* 🔥 FIX: Responsive Shimmer for Banner */}
          <div className="placeholder-glow mb-4">
            <div className="placeholder w-100 rounded-4 shadow-sm responsive-banner" style={{ backgroundColor: "#800000", opacity: 0.15 }}></div>
          </div>

          <div className="mb-3"><span className="placeholder col-4 bg-secondary opacity-25 rounded"></span></div>
          <div className="row g-3 placeholder-glow">
            {[1, 2, 3].map((i) => (
              <div key={i} className="col-12 col-md-6">
                <div className="card border-0 p-3" style={{ borderRadius: "20px", height: "180px", background: "#fff" }}>
                  <div className="d-flex justify-content-between mb-4">
                    <span className="placeholder col-3 bg-secondary opacity-10 rounded"></span>
                    <span className="placeholder col-2 bg-secondary opacity-10 rounded-pill"></span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center px-3">
                    <span className="placeholder rounded-circle bg-secondary opacity-10" style={{ width: '50px', height: '50px' }}></span>
                    <span className="placeholder col-2 bg-secondary opacity-10 rounded"></span>
                    <span className="placeholder rounded-circle bg-secondary opacity-10" style={{ width: '50px', height: '50px' }}></span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <BottomNavigation />
    </>
  );

  return (
    <>
      <Navbar />
      {/* 🚧 WORK IN PROGRESS MODAL RENDER - REMOVE THIS LINE WHEN WEBSITE IS READY */}
      {workInProgressModal}
      <div style={{ paddingBottom: "90px", background: "#f0f2f5", minHeight: "100vh" }} className="mt-5 pt-3">
        {/* <SportCategory /> */}

        <div className="container-fluid px-3 px-md-4 py-4">

          {/* 🔥 DYNAMIC BANNER SLIDER (React-Bootstrap) 🔥 */}
          {loadingBanners ? (
            // 💀 SHIMMER LOADER FOR BANNER
            <div className="placeholder-glow mb-4">
              <div className="placeholder w-100 rounded-4 shadow-sm responsive-banner" style={{ backgroundColor: "#800000", opacity: 0.15 }}></div>
            </div>
          ) : (
            // 🌟 ACTUAL SLIDER
            banners.length > 0 && (
              <Carousel
                className="mb-4 shadow-sm animate-fade-in custom-carousel"
                style={{ borderRadius: "20px", overflow: "hidden" }}
                interval={3000}       // Auto-slide every 3 seconds
                controls={false}      // Hides Left/Right Arrows (Phone me ajeeb lagte hain)
                indicators={true}     // Shows the bottom dots
                pause="hover"         // Touch/Hover karne par ruk jayega
              >
                {banners.map((banner, index) => (
                  <Carousel.Item key={banner._id || index}>
                    {/* 🔥 FIX: Responsive Image Class Maintained */}
                    <img
                      src={banner.imageUrl}
                      className="d-block w-100 object-fit-cover responsive-banner"
                      alt={`Promo Banner ${index + 1}`}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            )
          )}

          {/* Upcoming Matches Heading */}
          <div className="mb-3 d-flex align-items-center gap-2">
            <i className="bi bi-fire text-danger fs-5"></i>
            <h5 className="fw-bold mb-0 text-dark" style={{ letterSpacing: '-0.5px' }}>Upcoming Matches</h5>
          </div>

          {!loading && upcomingMatches.length === 0 && (
            <div className="text-center py-5 text-muted animate-fade-in">
              <div className="mb-3 bg-white rounded-circle d-inline-flex p-4 shadow-sm">
                <i className="bi bi-calendar-x fs-1 opacity-25"></i>
              </div>
              <p className="fw-medium">No upcoming matches found.</p>
            </div>
          )}

          <div className="row g-3">
            {upcomingMatches.filter(match => {
              const matchStatus = (match.status || "").toLowerCase();
              return matchStatus === "upcoming" || matchStatus === "lineup_out";
            }).map((match, index) => {

              // Colors & Formats
              const normalizedStatus = (match.status || "").toLowerCase();
              const formatInfo = getFormatStyle(match.matchType || "MATCH");
              const team1Color = match.team1?.color || "#333";
              const team2Color = match.team2?.color || "#333";
              const isLineupsOut = normalizedStatus === "lineup_out";
              const showLineupIndicator = normalizedStatus === "lineup_out";

              return (
                <div key={index} className="col-12 col-md-6 col-lg-4">
                  <div
                    className="card border-0 position-relative animate-fade-in card-hover overflow-hidden"
                    onClick={() => navigate(`/contests/${match.matchId}`, { state: { matchData: match } })}
                    style={{
                      borderRadius: "24px",
                      background: "#ffffff",
                      boxShadow: "0 10px 30px -10px rgba(0,0,0,0.08)",
                      cursor: "pointer",
                      border: isLineupsOut ? "1.5px solid #198754" : "1.5px solid transparent"
                    }}
                  >
                    {/* === CARD HEADER (Series Name & Format) === */}
                    <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom border-light bg-light bg-opacity-25">
                      <small className="text-muted text-uppercase fw-bold text-truncate" style={{ fontSize: '10px', maxWidth: '70%' }}>
                        {match.seriesName || match.matchType}
                      </small>
                      <span className="badge border-0 shadow-sm"
                        style={{ background: formatInfo.background, color: formatInfo.color, fontSize: '9px', letterSpacing: '0.5px' }}
                      >
                        {formatInfo.label}
                      </span>
                    </div>

                    {/* === TEAMS SECTION === */}
                    <div className="card-body py-3 px-2">
                      <div className="d-flex justify-content-between align-items-center px-2">

                        {/* Team 1 */}
                        <div className="d-flex flex-column align-items-center" style={{ width: '35%' }}>
                          <div className="position-relative">
                            <div className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                              style={{
                                width: "56px", height: "56px",
                                background: `linear-gradient(135deg, ${team1Color} 0%, #000 100%)`,
                                border: "3px solid #fff", color: "#fff", fontWeight: "800", fontSize: "14px"
                              }}
                            >
                              {match.team1?.image ? (
                                <img src={match.team1.image} alt="" className="w-100 h-100 rounded-circle object-fit-cover" />
                              ) : (
                                match.team1?.code?.[0] || "T1"
                              )}
                            </div>
                            <div className="position-absolute bottom-0 start-50 translate-middle-x bg-white px-2 rounded-pill border shadow-sm" style={{ fontSize: '9px', whiteSpace: 'nowrap', marginTop: '-10px' }}>
                              {match.team1?.code}
                            </div>
                          </div>
                          <div className="fw-bold text-dark text-truncate w-100 text-center mt-2" style={{ fontSize: "13px" }}>
                            {match.team1?.name}
                          </div>
                        </div>

                        {/* VS / Timer Center */}
                        <div className="text-center d-flex flex-column align-items-center" style={{ width: '30%' }}>
                          <span className="text-secondary opacity-25 fw-black" style={{ fontSize: "28px", fontFamily: 'sans-serif' }}>VS</span>
                          <div className="mt-1 d-flex align-items-center gap-1 text-danger bg-danger-subtle px-2 py-1 rounded-pill" style={{ fontSize: '10px', fontWeight: '600' }}>
                            <i className="bi bi-stopwatch"></i>
                            <CountdownTimer matchStartTime={match.matchStartTime || match.startTime} />
                          </div>
                        </div>

                        {/* Team 2 */}
                        <div className="d-flex flex-column align-items-center" style={{ width: '35%' }}>
                          <div className="position-relative">
                            <div className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                              style={{
                                width: "56px", height: "56px",
                                background: `linear-gradient(135deg, ${team2Color} 0%, #000 100%)`,
                                border: "3px solid #fff", color: "#fff", fontWeight: "800", fontSize: "14px"
                              }}
                            >
                              {match.team2?.image ? (
                                <img src={match.team2.image} alt="" className="w-100 h-100 rounded-circle object-fit-cover" />
                              ) : (
                                match.team2?.code?.[0] || "T2"
                              )}
                            </div>
                            <div className="position-absolute bottom-0 start-50 translate-middle-x bg-white px-2 rounded-pill border shadow-sm" style={{ fontSize: '9px', whiteSpace: 'nowrap' }}>
                              {match.team2?.code}
                            </div>
                          </div>
                          <div className="fw-bold text-dark text-truncate w-100 text-center mt-2" style={{ fontSize: "13px" }}>
                            {match.team2?.name}
                          </div>
                        </div>

                      </div>
                    </div>

                    {/* === BOTTOM STRIP === */}
                    <div className={`px-3 py-2 border-top d-flex justify-content-between align-items-center ${isLineupsOut ? "bg-success-subtle border-success-subtle" : "bg-light bg-opacity-50 border-light"}`}>
                      <div className="d-flex align-items-center gap-1">
                        <span className={`badge ${isLineupsOut ? "bg-success" : "bg-success-subtle text-success border border-success-subtle"} rounded-1`} style={{ fontSize: '9px' }}>MEGA</span>
                        <span className="fw-bold text-dark" style={{ fontSize: '11px' }}>₹50 Crores</span>
                      </div>
                      {showLineupIndicator ? (
                        <div className="d-flex align-items-center gap-1 text-success fw-bold" style={{ fontSize: '10px' }}>
                          <span className="opacity-blink" style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: '#198754', display: 'inline-block' }}></span>
                          <span>LINEUP OUT</span>
                        </div>
                      ) : isLineupsOut ? (
                        <div className="d-flex align-items-center gap-1 text-success fw-bold" style={{ fontSize: '10px' }}>
                          <i className="bi bi-check-circle-fill"></i>
                          <span>Team Available</span>
                        </div>
                      ) : (
                        <div className="d-flex align-items-center gap-1 text-muted" style={{ fontSize: '10px' }}>
                          <i className="bi bi-shield-check text-success"></i>
                          <span>Guaranteed</span>
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <style>{`
            .animate-fade-in { animation: fadeIn 0.5s ease-out; }
            .card-hover { transition: transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94); }
            .card-hover:active { transform: scale(0.98); }
            .blink-effect { animation: blink 1.5s infinite; }
            .opacity-blink { animation: opacityBlink 1.2s infinite; }
            .fw-black { font-weight: 900; }
            @keyframes fadeIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
            @keyframes blink { 50% { opacity: 0.5; } }
            @keyframes opacityBlink { 0%, 100% { opacity: 1; } 50% { opacity: 0.25; } }

            /* 🔥 FIX: RESPONSIVE BANNER HEIGHT */
            .responsive-banner {
                height: 100px; /* Mobile par patli strip */
                background-color: #800000;
            }
            
            @media (min-width: 768px) {
                .responsive-banner {
                    height: 160px; /* Laptop/Tablet par regular size */
                }
            }
        `}</style>
      </div>

      <BottomNavigation />
    </>
  );
}

export default Home;